import { List, Tag, Typography, Space } from "antd";
import { ClockCircleOutlined, PlayCircleOutlined, LockOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import type { LessonListItem as LessonItem } from "@/api/catalog";

const { Text } = Typography;

interface Props {
  lesson: LessonItem;
}

export function LessonRow({ lesson }: Props) {
  return (
    <List.Item
      style={{ padding: "12px 16px", borderRadius: 8 }}
      actions={[
        lesson.is_preview ? (
          <Tag icon={<PlayCircleOutlined />} color="green" key="preview">
            Xem trước
          </Tag>
        ) : (
          <Tag icon={<LockOutlined />} color="default" key="locked">
            Cần đăng ký
          </Tag>
        ),
      ]}
    >
      <Link
        to={`/lessons/${lesson.slug}`}
        style={{ flex: 1, color: "inherit", textDecoration: "none" }}
      >
        <Space size="middle">
          <Text strong style={{ color: "#7a8499", minWidth: 28 }}>
            {String(lesson.order).padStart(2, "0")}
          </Text>
          <div>
            <Text strong>{lesson.title}</Text>
            <div style={{ fontSize: 12, color: "#7a8499", marginTop: 2 }}>
              <ClockCircleOutlined /> {lesson.duration_minutes} phút
            </div>
          </div>
        </Space>
      </Link>
    </List.Item>
  );
}
